import { useParams, Link } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
import { getCategory, heroStyle } from "../data/site";
import { getArticlesByCategory } from "../data/articles";
import ArticleCard from "../components/ArticleCard";
import NotFound from "./NotFound";

function CategoryPage() {
  const { key } = useParams();
  const category = getCategory(key);
  if (!category) return <NotFound />;

  const articles = getArticlesByCategory(key);
  const isBlog = key === "blog";

  return (
    <>
      <section
        className={`fi-hero ${isBlog ? "text-center" : ""}`}
        style={{ padding: "6.5rem 0", ...heroStyle(category.banner) }}
      >
        <Container>
          <h1 className={isBlog ? "mb-0" : "mt-2"}>
            {isBlog ? category.label : ` ${category.label}`}
          </h1>
          {!isBlog && <p className="lead mb-0">{category.blurb}</p>}
        </Container>
      </section>

      <Container className="py-5">
        <Row className="g-4">
          {articles.map((a, i) => (
            <Col md={6} lg={4} key={a.slug}>
              {isBlog ? (
                <Link to={`/article/${a.slug}`} className="fi-blog-card text-decoration-none">
                  <div
                    className="fi-blog-top fi-blog-top-img"
                    style={{ backgroundImage: `url(${a.image})` }}
                  >
                    <span className="fi-blog-tag">📰 Blog</span>
                    <span className="fi-blog-num">{String(i + 1).padStart(2, "0")}</span>
                  </div>
                  <div className="fi-blog-body">
                    <h5 className="title">{a.title}</h5>
                    <p className="text-muted">{a.excerpt}</p>
                    <span className="fi-blog-link">
                      Read article <span className="arrow">→</span>
                    </span>
                  </div>
                </Link>
              ) : (
                <ArticleCard article={a} />
              )}
            </Col>
          ))}
        </Row>
        {articles.length === 0 && (
          <p className="text-center text-muted py-5">
            New articles in this section are coming soon. 📝
          </p>
        )}
      </Container>
    </>
  );
}

export default CategoryPage;
